import { useInfiniteQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { Cookies } from 'react-cookie';
import { toast } from 'react-toastify';
import { ZodError } from 'zod';
import { attachApiErrorToastInterceptor } from '../../../utils/api-error-toast';

export const axiosIns = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_MENUITEM_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosIns);

axiosIns.interceptors.request.use((config) => {
  const cookies = new Cookies();
  const token = cookies.get('session_token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

type useGetRestaurantMenuItemsArg = {
  restaurantId: string;
  enableIf: boolean;
};

const getResturantMenuItem = async ({ pageParam, queryKey }: any) => {
  type Params = {
    page_number: number;
    items_per_page: number;
    category_id: number;
  };

  let params: Partial<Params> = {};

  if (queryKey[2] === 0) {
    params = {
      items_per_page: 10,
      page_number: pageParam,
    };
  } else {
    params = {
      items_per_page: 10,
      page_number: pageParam,
      category_id: queryKey[2],
    };
  }

  try {
    const response = await axiosIns.get(`/restaurant/${queryKey[1]}`, {
      params,
    });
    return response.data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      console.log(
        `${process.env.REACT_APP_API_BASE_MENUITEM_URL}/restaurant/${queryKey[1]}: `,
        error?.response?.data?.message,
      );
      toast.error(error?.response?.data?.message ?? 'API validation failed');
    }
  }
};

export const useGetRestaurantMenuItems = (arg: useGetRestaurantMenuItemsArg) => {
  return useInfiniteQuery({
    queryKey: ['restaurant-menu-items', arg.restaurantId],
    queryFn: getResturantMenuItem,
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      return lastPage?.next_page;
    },
    enabled: arg.enableIf,
  });
};
